import styles from './Motability7Slide.module.scss';
import React, { useRef } from 'react';
import { EffectCreative, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

export default function Slide({ slide }) {
  const swiperRef = useRef(null);

  // 从 Sitecore 数据中提取图片 URL，支持响应式图片
  const getImageUrl = (imageField) => {
    if (!imageField?.fields) return '';

    // 优先使用 desktopImage，然后是 tabletImage，最后是 mobileImage
    return (
      imageField.fields.desktopImage?.value?.src ||
      imageField.fields.tabletImage?.value?.src ||
      imageField.fields.mobileImage?.value?.src ||
      ''
    );
  };

  const imageUrl = getImageUrl(slide?.fields?.image);

  return (
    <div className={styles.wrapper} data-aos="fade-up">
      <Swiper
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        grabCursor={true}
        effect="creative"
        loop={true}
        speed={800}
        creativeEffect={{
          prev: {
            shadow: false,
            translate: ['-120%', 0, -500],
          },
          next: {
            shadow: false,
            translate: ['120%', 0, -500],
          },
        }}
        modules={[Navigation, EffectCreative]}
        className="mySwiper2"
      >
        <SwiperSlide key={slide.index}>
          <div className={styles.slideImage}>
            {imageUrl && <img src={imageUrl} alt="Car image" width={777} height={429} />}
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
}
